module.exports = __webpack_public_path__ + "img/BMW_White-Colour_RGB.d2559c78.png";